import axios from "axios";
import { GetAllMacrouseDTO, GetAllMacrouseFiltersDTO, GetAllParcelsDTO, GetAllParcelsFiltersDTO, GetAllSpeciesDTO, GetAllSpeciesFiltersDTO, GetAllVarietyDTO, GetAllVarietyFiltersDTO, MacrouseDTO, MacrouseReviewDTO, ParcelBulkUpdateDTO, ParcelDTO, SpeciesDTO, VarietyDTO } from "./dto";
import { MacrouseService, ParcelService, SpeciesService, VarietyService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { downloadFileFromResponse } from "../../../../../utils/download";

export class MacrouseServiceImpl implements MacrouseService {
    public CreateMacrouse(data: MacrouseDTO): Promise<void> {
        return axios.post("/api/macrouse",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateMacrouse(data: MacrouseDTO, id: string): Promise<void> {
        return axios.put("/api/macrouse/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteMacrouse(id: string): Promise<void> {
        return axios.delete("/api/macrouse/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllMacrouse(filters: GetAllMacrouseFiltersDTO): Promise<GetAllMacrouseDTO> {
        return axios.get("/api/macrouse", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetMacrouseById(id: string): Promise<MacrouseDTO> {
        return axios.get("/api/macrouse/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}

export class SpeciesServiceImpl implements SpeciesService {

    public CreateSpecies(data: SpeciesDTO): Promise<void> {
        return axios.post("/api/species",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateSpecies(data: SpeciesDTO, id: string): Promise<void> {
        return axios.put("/api/species" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteSpecies(id: string): Promise<void> {
        return axios.delete("/api/species/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllSpecies(filters: GetAllSpeciesFiltersDTO): Promise<GetAllSpeciesDTO> {
        return axios.get("/api/species", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetSpeciesById(id: string): Promise<SpeciesDTO> {
        return axios.get("/api/macrouse/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}

export class VarietyServiceImpl implements VarietyService {

    public CreateVariety(data: VarietyDTO): Promise<void> {
        return axios.post("/api/variety",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateVariety(data: VarietyDTO, id: string): Promise<void> {
        return axios.put("/api/variety" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteVariety(id: string): Promise<void> {
        return axios.delete("/api/variety/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllVariety(filters: GetAllVarietyFiltersDTO): Promise<GetAllVarietyDTO> {
        return axios.get("/api/variety", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetVarietyById(id: string): Promise<VarietyDTO> {
        return axios.get("/api/variety/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}

export class ParcelServiceImpl implements ParcelService {

    public CreateParcel(data: ParcelDTO): Promise<void> {
        return axios.post("/api/parcel",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateParcel(data: ParcelDTO, id: string): Promise<void> {
        return axios.put("/api/parcel" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public BulkUpdateParcel(data: ParcelBulkUpdateDTO): Promise<void> {
        return axios.put("/api/parcel/bulk-update",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public CopyParcelFromNotification(prevNotId: string, currNotId: string): Promise<void> {
        return axios.put(`/api/parcel/copy-from-notification/${prevNotId}/${currNotId}`,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateParcelsFromCsv(data: FormData): Promise<void> {
        return axios.put("/api/parcel/update-parcels-from-csv",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteParcel(id: string): Promise<void> {
        return axios.delete("/api/parcel/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllParcel(filters: GetAllParcelsFiltersDTO): Promise<GetAllParcelsDTO> {
        return axios.get("/api/parcel", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetParcelById(id: string): Promise<ParcelDTO> {
        return axios.get("/api/parcel/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public IdentificationBoardNotification(notId: string): Promise<any> {
        console.log('scheda service')
        return axios.get("/api/download/identification-board-pdf/"+notId, {
            params: {
                notId: notId,
                
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => {

            downloadFileFromResponse(response.data, 'scheda_identificativa.pdf', 'application/pdf');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

    public GetMacrouseNot(id: string): Promise<MacrouseReviewDTO> {
        return axios.get("/api/parcel/grouped-by-macrouse/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public ExportCurrentAndPreviousNotifications(currNotId: string, prevNotId?: string): Promise<any> {
        return axios.get("/api/download/export-previous-and-current-notifications", {
            params: {
                currentNotificationId: currNotId,
                previousNotificationId: prevNotId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => {


            downloadFileFromResponse(response.data, 'protocollo.csv', 'text/csv;charset=utf-8;');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

    public ExportCompleteNotification(notId: string): Promise<any> {
        return axios.get("/api/download/export-complete-notification/" + notId, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => {

            downloadFileFromResponse(response.data, 'protocollo.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }



}